<template>
  <div class="page-content">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { toRefs, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useProfile } from '@/use/profile';

const router = useRouter();

const { userRoles } = useProfile();
const { isGoGoEmployee } = toRefs(userRoles);
const { customerInfo } = useCustomer();

onMounted(() => {
  const ifOperatorViewingFamilyDashboardRequireCustomerToBeLoadedOnRightPanel = isGoGoEmployee.value && !customerInfo.value?.id;
  if (ifOperatorViewingFamilyDashboardRequireCustomerToBeLoadedOnRightPanel) {
    router.push({
      name: 'Profile',
    });
  }

  util.moveToTop();
});
</script>

<style lang="scss">
.coming-soon-message {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
  color: #088675;
}
</style>
